import React, { useEffect } from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
// Store
import { useDispatch } from 'react-redux';
import { logoutUser } from '../../redux/user/actions';
import { systemErrorMounted } from '../../redux/appreadouts/actions';
// Interfaces
import { ISystemError } from '../../interfaces/systemerror.interfaces';
// Styles
import styles from './systemerror.module.scss';
import { Button, Footer, UserHeader } from '..';

interface ISystemErrorProps {
    location?: { state?: ISystemError };
    history?: { goBack?: () => void };
}

export const SystemError = ({ location, history }: ISystemErrorProps): JSX.Element => {
    const dispatch = useDispatch();
    const systemError = location?.state as ISystemError;

    useEffect(() => {
        dispatch(systemErrorMounted(true));

        return (): void => {
            dispatch(systemErrorMounted(false));
        };
    }, []);

    const handleLogoutClick = (): void => {
        dispatch(logoutUser());
    };

    const goBack = Boolean(history)
        ? history?.goBack
        : (): void => {
              globalThis?.history?.go(-1);
          };

    return (
        <div className="d-flex h-100">
            <div className={`d-flex flex-column flex-fill overflow-auto ${styles.errorPage}`}>
                <nav className={styles.header}>
                    <UserHeader withSearch={false} withLogo />
                </nav>

                <section className="d-flex flex-fill align-items-center justify-content-center">
                    <section className={`d-flex flex-column ${styles.content}`}>
                        <FormattedHTMLMessage
                            tagName="div"
                            id="SYSTEM_ERROR"
                            values={{ errorCode: systemError?.error }}
                        />

                        {!systemError?.errorMessage ? null : (
                            <FormattedHTMLMessage
                                tagName="div"
                                id="SYSTEM_ERROR_TRANSACTION_ID"
                                values={{ transactionId: systemError?.errorMessage }}
                            />
                        )}

                        <section className="d-flex mt-4 flex-column flex-sm-row justify-content-sm-between">
                            <Button type="button" onClick={goBack}>
                                <FormattedMessage id="BACK" />
                            </Button>

                            <Button type="button" onClick={handleLogoutClick}>
                                <FormattedMessage id="LOG_ON" />
                            </Button>
                        </section>
                    </section>
                </section>

                <Footer />
            </div>
        </div>
    );
};

export default SystemError;
